import React from 'react'
// Local
import { shouldRenderReskin2025 } from '../../constant'
import ReveleerCoachingBox from '../ReveleerCoachingBox'

type Props = {
  items: string[]
}

function AlertBar(props: Props): JSX.Element {
  const { items } = props
  if (shouldRenderReskin2025) {
    return (
      <ReveleerCoachingBox
        coachingBoxType="error"
        isShowing
        message={
          <span>
            Action Recommended ({ items.length })
          </span>
        }
      />
    )
  }
  return (
    <div
      className="curation-ui-alert-bar"
      id="curation-ui-alert-bar"
    >
      <div className="title">
        <div className="alert-badge">{ items.length }</div>
        <span>Action Recommended</span>
      </div>
    </div>
  )
}

export default AlertBar
